// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"63941ca6","527":"9c871870","667":"9d42249c"}[chunkId] + ".chunk.css";
};